import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.user.isAdmin ? _c('div', [_c('ix-header-portfolio'), _vm._v(" "), _c(VDataTable, {
    staticClass: "flex-grow-1",
    attrs: {
      "multi-sort": "",
      "fixed-header": "",
      "height": 'calc(100vh - 210px)',
      "locale": _setup.$i18n.locale,
      "loading": _setup.loading,
      "items": _setup.items,
      "headers": _setup.headers.map(function (h) {
        return _objectSpread(_objectSpread({}, h), {}, {
          text: _vm.$t(h.value)
        });
      }),
      "options": _setup.options,
      "server-items-length": _setup.itemCount,
      "sort-by": "name",
      "footer-props": {
        'items-per-page-options': [15, 30, 50, -1]
      },
      "items-per-page": _setup.options.itemsPerPage,
      "item-key": "id",
      "show-select": "",
      "show-expand": "",
      "expanded": _setup.expanded,
      "single-expand": true
    },
    on: {
      "update:options": function updateOptions($event) {
        _setup.options = $event;
      },
      "update:expanded": function updateExpanded($event) {
        _setup.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header.taxonomy",
      fn: function fn(_ref) {
        var header = _ref.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.assignedToFiltersLength ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.assignedToFiltersLength
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c('ix-data-table-taxonomy', {
          attrs: {
            "show-select": true,
            "single-select": true
          },
          model: {
            value: _setup.taxonomiesFilters,
            callback: function callback($$v) {
              _setup.taxonomiesFilters = $$v;
            },
            expression: "taxonomiesFilters"
          }
        })], 1)];
      }
    }, {
      key: "header.assignedTo",
      fn: function fn(_ref3) {
        var header = _ref3.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.assignedToFiltersLength ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.assignedToFiltersLength
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c(VList, [_c(VListItemGroup, {
          attrs: {
            "multiple": ""
          },
          model: {
            value: _setup.assignedToFilters,
            callback: function callback($$v) {
              _setup.assignedToFilters = $$v;
            },
            expression: "assignedToFilters"
          }
        }, _vm._l([_setup.TypeMetricAssignedTo.Fund, _setup.TypeMetricAssignedTo.Company, _setup.TypeMetricAssignedTo.FundCompany, _setup.TypeMetricAssignedTo.FundMgmt, null], function (item) {
          return _c(VListItem, {
            key: item,
            attrs: {
              "value": item
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref5) {
                var active = _ref5.active;
                return [_c(VListItemAction, [_c(VCheckbox, {
                  attrs: {
                    "input-value": active,
                    "color": "primary"
                  }
                })], 1), _vm._v(" "), _c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item))])], 1)];
              }
            }], null, true)
          });
        }), 1)], 1)], 1)];
      }
    }, {
      key: "header.sections",
      fn: function fn(_ref6) {
        var header = _ref6.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": "",
            "content-class": "bg-white"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.sectionsFilters && _setup.sectionsFilters.length ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.sectionsFilters.length
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c('ix-data-table-sections', {
          staticClass: "max-w-[680px]",
          attrs: {
            "height": 'calc(100vh - 500px)',
            "show-select": true,
            "columns": ['id', 'labelI18n.en', 'labelI18n.de'],
            "default-filters": {
              linkedToMetrics: true
            }
          },
          model: {
            value: _setup.sectionsFilters,
            callback: function callback($$v) {
              _setup.sectionsFilters = $$v;
            },
            expression: "sectionsFilters"
          }
        })], 1)];
      }
    }, {
      key: "header.isComputed",
      fn: function fn(_ref8) {
        var header = _ref8.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": "",
            "content-class": "bg-white"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref9) {
              var on = _ref9.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.isComputedFilter.length ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.isComputedFilter
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c(VList, {
          staticClass: "h-[100px]"
        }, [_c(VListItemGroup, {
          attrs: {
            "multiple": ""
          },
          model: {
            value: _setup.isComputedFilter,
            callback: function callback($$v) {
              _setup.isComputedFilter = $$v;
            },
            expression: "isComputedFilter"
          }
        }, _vm._l([true, false], function (item) {
          return _c(VListItem, {
            key: item,
            attrs: {
              "value": item
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref10) {
                var active = _ref10.active;
                return [_c(VListItemAction, [_c(VCheckbox, {
                  attrs: {
                    "input-value": active,
                    "color": "primary"
                  }
                })], 1), _vm._v(" "), _c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item))])], 1)];
              }
            }], null, true)
          });
        }), 1)], 1)], 1)];
      }
    }, {
      key: "header.allowQuarterlyInput",
      fn: function fn(_ref11) {
        var header = _ref11.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": "",
            "content-class": "bg-white"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref12) {
              var on = _ref12.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.allowQuarterlyInputFilter.length ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.allowQuarterlyInputFilter
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c(VList, {
          staticClass: "h-[100px]"
        }, [_c(VListItemGroup, {
          attrs: {
            "multiple": ""
          },
          model: {
            value: _setup.allowQuarterlyInputFilter,
            callback: function callback($$v) {
              _setup.allowQuarterlyInputFilter = $$v;
            },
            expression: "allowQuarterlyInputFilter"
          }
        }, _vm._l([true, false], function (item) {
          return _c(VListItem, {
            key: item,
            attrs: {
              "value": item
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref13) {
                var active = _ref13.active;
                return [_c(VListItemAction, [_c(VCheckbox, {
                  attrs: {
                    "input-value": active,
                    "color": "primary"
                  }
                })], 1), _vm._v(" "), _c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item))])], 1)];
              }
            }], null, true)
          });
        }), 1)], 1)], 1)];
      }
    }, {
      key: "header.defaultReportingPeriodType",
      fn: function fn(_ref14) {
        var header = _ref14.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": "",
            "content-class": "bg-white"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref15) {
              var on = _ref15.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.defaultReportingPeriodTypeFilter.length ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.defaultReportingPeriodTypeFilter
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c(VList, [_c(VListItemGroup, {
          attrs: {
            "multiple": ""
          },
          model: {
            value: _setup.defaultReportingPeriodTypeFilter,
            callback: function callback($$v) {
              _setup.defaultReportingPeriodTypeFilter = $$v;
            },
            expression: "defaultReportingPeriodTypeFilter"
          }
        }, _vm._l([{
          text: _vm.$t('reportingPeriodType.monthly'),
          value: _setup.MetricReportingPeriodType.Monthly
        }, {
          text: _vm.$t('reportingPeriodType.quarterly'),
          value: _setup.MetricReportingPeriodType.Quarterly
        }, {
          text: _vm.$t('reportingPeriodType.annual'),
          value: _setup.MetricReportingPeriodType.Annual
        }], function (item) {
          return _c(VListItem, {
            key: item.value,
            attrs: {
              "value": item.value
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref16) {
                var active = _ref16.active;
                return [_c(VListItemAction, [_c(VCheckbox, {
                  attrs: {
                    "input-value": active,
                    "color": "primary"
                  }
                })], 1), _vm._v(" "), _c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.text))])], 1)];
              }
            }], null, true)
          });
        }), 1)], 1)], 1)];
      }
    }, {
      key: "header.category",
      fn: function fn(_ref17) {
        var header = _ref17.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": "",
            "content-class": "bg-white"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref18) {
              var on = _ref18.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.categoryFilters.length || _setup.filterNoCategory ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.categoryFilters.length || '1'
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c('div', {
          staticClass: "bg-white"
        }, [_c(VList, {
          attrs: {
            "dense": ""
          }
        }, [_c(VListItem, [_c(VListItemAction, [_c(VCheckbox, {
          attrs: {
            "color": "primary"
          },
          on: {
            "change": _setup.handleNoCategoryChange
          },
          model: {
            value: _setup.filterNoCategory,
            callback: function callback($$v) {
              _setup.filterNoCategory = $$v;
            },
            expression: "filterNoCategory"
          }
        })], 1), _vm._v(" "), _c(VListItemContent, [_c(VListItemTitle, [_vm._v("No Category")])], 1)], 1)], 1), _vm._v(" "), _c(VDivider), _vm._v(" "), _c('ix-data-table-categories', {
          staticClass: "max-w-[680px]",
          attrs: {
            "disabled": _setup.filterNoCategory,
            "height": 'calc(100vh - 500px)',
            "show-select": true,
            "columns": ['id', 'label']
          },
          model: {
            value: _setup.categoryFilters,
            callback: function callback($$v) {
              _setup.categoryFilters = $$v;
            },
            expression: "categoryFilters"
          }
        })], 1)])];
      }
    }, {
      key: "header.isAdminKpi",
      fn: function fn(_ref19) {
        var header = _ref19.header;
        return [_vm._v("\n      " + _vm._s(header.text) + "\n      "), _c(VMenu, {
          attrs: {
            "bottom": "",
            "close-on-content-click": false,
            "left": "",
            "content-class": "bg-white"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref20) {
              var on = _ref20.on;
              return [_c(VBtn, _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_setup.isAdminKpiFilter.length ? _c(VBadge, {
                attrs: {
                  "color": "green",
                  "content": _setup.isAdminKpiFilter.length
                }
              }, [_c(VIcon, [_vm._v("mdi-filter")])], 1) : _c(VIcon, [_vm._v("mdi-filter-outline")])], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c(VList, {
          staticClass: "h-[100px]"
        }, [_c(VListItemGroup, {
          attrs: {
            "multiple": ""
          },
          model: {
            value: _setup.isAdminKpiFilter,
            callback: function callback($$v) {
              _setup.isAdminKpiFilter = $$v;
            },
            expression: "isAdminKpiFilter"
          }
        }, _vm._l([true, false], function (item) {
          return _c(VListItem, {
            key: item,
            attrs: {
              "value": item
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function fn(_ref21) {
                var active = _ref21.active;
                return [_c(VListItemAction, [_c(VCheckbox, {
                  attrs: {
                    "input-value": active,
                    "color": "primary"
                  }
                })], 1), _vm._v(" "), _c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item ? 'Admin' : 'User'))])], 1)];
              }
            }], null, true)
          });
        }), 1)], 1)], 1)];
      }
    }, {
      key: "top",
      fn: function fn() {
        return [_c(VToolbar, {
          attrs: {
            "flat": ""
          }
        }, [_c(VToolbarTitle, [_vm._v("Metrics / KPIs")]), _vm._v(" "), _c(VDivider, {
          staticClass: "mx-4",
          attrs: {
            "inset": "",
            "vertical": ""
          }
        }), _vm._v(" "), _c(VSpacer), _vm._v(" "), _c(VTextField, {
          staticClass: "mx-4",
          attrs: {
            "value": _setup.routeSearchValue,
            "append-icon": "mdi-magnify",
            "label": "Search",
            "single-line": "",
            "hide-details": ""
          },
          on: {
            "input": function input(v) {
              _vm.$router.push({
                query: {
                  search: v
                }
              });
            }
          }
        }), _vm._v(" "), _c(VDialog, {
          attrs: {
            "max-width": "50%"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref22) {
              var on = _ref22.on,
                attrs = _ref22.attrs;
              return [_c(VBtn, _vm._g(_vm._b({
                staticClass: "mb-2",
                attrs: {
                  "color": "primary",
                  "dark": ""
                },
                on: {
                  "click": function click() {
                    _setup.newItem = {
                      nameI18n: {},
                      descriptionI18n: {},
                      usageGuidanceI18n: {}
                    };
                    _setup.createDialog = true;
                  }
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n              " + _vm._s(_vm.$t('add')) + "\n            ")])];
            }
          }], null, false, 1332339453),
          model: {
            value: _setup.createDialog,
            callback: function callback($$v) {
              _setup.createDialog = $$v;
            },
            expression: "createDialog"
          }
        }, [_vm._v(" "), _c('ix-kpi-edit', {
          attrs: {
            "item": _setup.newItem
          },
          on: {
            "upsert": _setup.handleUpsert,
            "input": function input(v) {
              return _setup.createDialog = v;
            }
          }
        })], 1), _vm._v(" "), _c(VBtn, {
          staticClass: "mb-2",
          attrs: {
            "color": "primary",
            "dark": ""
          },
          on: {
            "click": _setup.refetch
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$t('refresh')) + "\n        ")])], 1)];
      },
      proxy: true
    }, {
      key: "item.id",
      fn: function fn(_ref23) {
        var item = _ref23.item;
        return [_vm._v(_vm._s(item.id))];
      }
    }, {
      key: "expanded-item",
      fn: function fn(_ref24) {
        var headers = _ref24.headers,
          item = _ref24.item;
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [item.id && item.id === _setup.expandedMetricId ? _c(VRow, [_c(VCol, {
          attrs: {
            "cols": "6"
          }
        }, [_setup.hasComputationalChildren ? _c('div', {
          staticClass: "font-weight-bold mb-2 d-flex align-center"
        }, [_c('span', [_vm._v("Direct computational children")]), _vm._v(" "), _c(VTooltip, {
          attrs: {
            "right": "",
            "max-width": "420"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref25) {
              var on = _ref25.on,
                attrs = _ref25.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "ml-1",
                attrs: {
                  "small": "",
                  "color": "primary"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n                    mdi-information-outline\n                  ")])];
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("\n                  KPIs used directly in this KPI's formula. Example: if \"Total emissions\"\n                  is computed as \"$result_101 + $result_102\", then KPIs 101 and 102 are\n                  direct computational children of \"Total emissions\".\n                ")])])], 1) : _vm._e(), _vm._v(" "), _setup.hasComputationalChildren ? _c('ix-data-table-metrics', {
          attrs: {
            "height": '300px',
            "show-selected": false,
            "show-filters": false,
            "allow-edit": false,
            "allow-custom": false,
            "show-action": false,
            "use-all-sections": true,
            "query": _setup.buildRelationshipQuery(item.id, _setup.MetricDependencyType.Computational, 'children')
          }
        }) : _vm._e(), _vm._v(" "), _setup.hasConditionalChildren ? _c('div', {
          staticClass: "font-weight-bold mt-4 mb-2 d-flex align-center"
        }, [_c('span', [_vm._v("Direct conditional children")]), _vm._v(" "), _c(VTooltip, {
          attrs: {
            "right": "",
            "max-width": "420"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref26) {
              var on = _ref26.on,
                attrs = _ref26.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "ml-1",
                attrs: {
                  "small": "",
                  "color": "primary"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n                    mdi-information-outline\n                  ")])];
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("\n                  KPIs referenced directly in this KPI's conditions. Example: if a KPI is\n                  shown only when \"$result_220 == 1\", then KPI 220 is a direct conditional\n                  child.\n                ")])])], 1) : _vm._e(), _vm._v(" "), _setup.hasConditionalChildren ? _c('ix-data-table-metrics', {
          attrs: {
            "height": '300px',
            "show-selected": false,
            "show-filters": false,
            "allow-edit": false,
            "allow-custom": false,
            "show-action": false,
            "use-all-sections": true,
            "query": _setup.buildRelationshipQuery(item.id, _setup.MetricDependencyType.Conditional, 'children')
          }
        }) : _vm._e(), _vm._v(" "), _setup.hasComputationalParents ? _c('div', {
          staticClass: "font-weight-bold mt-4 mb-2 d-flex align-center"
        }, [_c('span', [_vm._v("Direct computational parents")]), _vm._v(" "), _c(VTooltip, {
          attrs: {
            "right": "",
            "max-width": "420"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref27) {
              var on = _ref27.on,
                attrs = _ref27.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "ml-1",
                attrs: {
                  "small": "",
                  "color": "primary"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n                    mdi-information-outline\n                  ")])];
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("\n                  KPIs whose formulas directly use this KPI. Example: if KPI 330's formula\n                  contains \"$result_200 * 100\", then KPI 330 is a direct computational\n                  parent of KPI 200.\n                ")])])], 1) : _vm._e(), _vm._v(" "), _setup.hasComputationalParents ? _c('ix-data-table-metrics', {
          attrs: {
            "height": '300px',
            "show-selected": false,
            "show-filters": false,
            "allow-edit": false,
            "allow-custom": false,
            "show-action": false,
            "use-all-sections": true,
            "query": _setup.buildRelationshipQuery(item.id, _setup.MetricDependencyType.Computational, 'parents')
          }
        }) : _vm._e(), _vm._v(" "), _setup.hasConditionalParents ? _c('div', {
          staticClass: "font-weight-bold mt-4 mb-2 d-flex align-center"
        }, [_c('span', [_vm._v("Direct conditional parents")]), _vm._v(" "), _c(VTooltip, {
          attrs: {
            "right": "",
            "max-width": "420"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref28) {
              var on = _ref28.on,
                attrs = _ref28.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "ml-1",
                attrs: {
                  "small": "",
                  "color": "primary"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n                    mdi-information-outline\n                  ")])];
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("\n                  KPIs whose conditions directly reference this KPI. Example: if KPI 410\n                  appears only when \"$result_200 == 1\", then KPI 410 is a direct\n                  conditional parent of KPI 200.\n                ")])])], 1) : _vm._e(), _vm._v(" "), _setup.hasConditionalParents ? _c('ix-data-table-metrics', {
          attrs: {
            "height": '300px',
            "show-selected": false,
            "show-filters": false,
            "allow-edit": false,
            "allow-custom": false,
            "show-action": false,
            "use-all-sections": true,
            "query": _setup.buildRelationshipQuery(item.id, _setup.MetricDependencyType.Conditional, 'parents')
          }
        }) : _vm._e(), _vm._v(" "), !_setup.hasAnyRelationships ? _c(VAlert, {
          attrs: {
            "type": "info",
            "outlined": "",
            "dense": ""
          }
        }, [_vm._v("\n              No direct conditional/computational parent or child relationships.\n            ")]) : _vm._e()], 1), _vm._v(" "), _c(VCol, {
          attrs: {
            "cols": "6"
          }
        }, [_c('ix-data-table-audit-logs', {
          staticClass: "max-h-[800px] overflow-scroll",
          attrs: {
            "columns": ['change', 'operationType', 'createdBy', 'createdAt'],
            "default-filters": {
              tableName: ['metric'],
              dataId: '00000000-0000-0000-0000-' + item.id.toString(16).padStart(12, '0')
            }
          }
        })], 1)], 1) : _vm._e()], 1)];
      }
    }, {
      key: "item.name",
      fn: function fn(_ref29) {
        var item = _ref29.item;
        return [_c('metrics-cells-metric-name', {
          attrs: {
            "id": item.id,
            "name": item.name,
            "is-computed": item.isComputed,
            "metric-assignment": item,
            "search": Array.isArray(_vm.$route.query.search) ? _vm.$route.query.search[0] || '' : _vm.$route.query.search || ''
          }
        })];
      }
    }, {
      key: "item.category",
      fn: function fn(_ref30) {
        var item = _ref30.item;
        return [_vm._v("\n      " + _vm._s(_setup.getCategoryLabel(item)) + "\n    ")];
      }
    }, {
      key: "item.valueOptions",
      fn: function fn(_ref31) {
        var item = _ref31.item;
        return [_vm._l((item.valueOptions && item.valueOptions.options || []).slice(0, 2), function (option, idx) {
          return _c(VChip, {
            key: _setup.getValueOptionKey(option, idx),
            staticClass: "max-w-[85px] inline-block",
            attrs: {
              "outlined": "",
              "label": ""
            }
          }, [_c(VTooltip, {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function fn(_ref32) {
                var on = _ref32.on,
                  attrs = _ref32.attrs;
                return [_c('span', _vm._g(_vm._b({
                  staticClass: "text-truncate"
                }, 'span', attrs, false), on), [_vm._v("\n              " + _vm._s(option.text || option) + "\n            ")])];
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(option.text || option) + "\n          ")])])], 1);
        }), _vm._v(" "), (item.valueOptions && item.valueOptions.options || []).length > 2 ? _c(VTooltip, {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref33) {
              var on = _ref33.on,
                attrs = _ref33.attrs;
              return [_c('span', _vm._g(_vm._b({
                attrs: {
                  "small": ""
                }
              }, 'span', attrs, false), on), [_vm._v("...")])];
            }
          }], null, true)
        }, [_vm._v(" "), _vm._l(item.valueOptions.options || [], function (option, idx) {
          return _c(VChip, {
            key: _setup.getValueOptionKey(option, idx),
            attrs: {
              "outlined": "",
              "label": ""
            }
          }, [_vm._v("\n          " + _vm._s(option.text || option) + "\n        ")]);
        })], 2) : _vm._e()];
      }
    }, {
      key: "item.sections",
      fn: function fn(_ref34) {
        var item = _ref34.item;
        return [_vm._l((item.sections || []).slice(0, 2), function (section) {
          return _c(VChip, {
            key: section.id,
            attrs: {
              "outlined": "",
              "label": ""
            }
          }, [_vm._v("\n        " + _vm._s(section.label) + "\n      ")]);
        }), _vm._v(" "), (item.sections || []).length > 2 ? _c(VTooltip, {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref35) {
              var on = _ref35.on,
                attrs = _ref35.attrs;
              return [_c('span', _vm._g(_vm._b({
                attrs: {
                  "small": ""
                }
              }, 'span', attrs, false), on), [_vm._v("...")])];
            }
          }], null, true)
        }, [_vm._v(" "), _vm._l(item.sections || [], function (section) {
          return _c(VChip, {
            key: section.id,
            attrs: {
              "outlined": "",
              "label": ""
            }
          }, [_vm._v("\n          " + _vm._s(section.label) + "\n        ")]);
        })], 2) : _vm._e()];
      }
    }, {
      key: "item.taxonomy",
      fn: function fn(_ref36) {
        var item = _ref36.item;
        return [item.taxonomy ? _c(VChip, {
          attrs: {
            "outlined": "",
            "label": ""
          }
        }, [_vm._v("\n        " + _vm._s(item.taxonomy.label) + "\n      ")]) : _vm._e()];
      }
    }, {
      key: "item.externalData",
      fn: function fn(_ref37) {
        var item = _ref37.item;
        return [_c('div', {
          staticClass: "d-flex align-center flex-wrap"
        }, _vm._l(Object.entries(item.externalData || {}), function (_ref38) {
          var _ref39 = _slicedToArray(_ref38, 2),
            key = _ref39[0],
            val = _ref39[1];
          return _c(VChip, {
            key: key,
            staticClass: "ma-1",
            attrs: {
              "outlined": "",
              "label": ""
            }
          }, [_vm._v("\n          " + _vm._s(key) + ": " + _vm._s(val) + "\n        ")]);
        }), 1)];
      }
    }, {
      key: "item.isComputed",
      fn: function fn(_ref40) {
        var item = _ref40.item;
        return [_c(VCheckbox, {
          attrs: {
            "disabled": "",
            "label": ""
          },
          model: {
            value: item.isComputed,
            callback: function callback($$v) {
              _vm.$set(item, "isComputed", $$v);
            },
            expression: "item.isComputed"
          }
        })];
      }
    }, {
      key: "item.defaultReportingPeriodType",
      fn: function fn(_ref41) {
        var item = _ref41.item;
        return [_c('ix-chip-reporting-period-type', {
          attrs: {
            "type": item.defaultReportingPeriodType
          }
        })];
      }
    }, {
      key: "item.allowQuarterlyInput",
      fn: function fn(_ref42) {
        var item = _ref42.item;
        return [_c(VCheckbox, {
          attrs: {
            "disabled": "",
            "label": ""
          },
          model: {
            value: item.allowQuarterlyInput,
            callback: function callback($$v) {
              _vm.$set(item, "allowQuarterlyInput", $$v);
            },
            expression: "item.allowQuarterlyInput"
          }
        })];
      }
    }, {
      key: "item.isAdminKpi",
      fn: function fn(_ref43) {
        var item = _ref43.item;
        return [item.createdBy === 'aa5411ec-dccf-a4f2-f85d-be852a28c090' ? _c(VChip, {
          attrs: {
            "color": "success",
            "outlined": "",
            "label": ""
          }
        }, [_c(VIcon, {
          staticClass: "mr-1"
        }, [_vm._v("mdi-shield-account")]), _vm._v("\n        Admin\n      ")], 1) : _c(VChip, {
          attrs: {
            "color": "primary",
            "outlined": "",
            "label": ""
          }
        }, [_c(VIcon, {
          staticClass: "mr-1"
        }, [_vm._v("mdi-account")]), _vm._v("\n        User\n      ")], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref44) {
        var item = _ref44.item;
        return [_c(VLayout, {
          staticClass: "flex-nowrap pa-4",
          attrs: {
            "row": ""
          }
        }, [item.external_url !== undefined ? _c(VTooltip, {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref45) {
              var on = _ref45.on,
                attrs = _ref45.attrs;
              return [_c('ix-button-white', _vm._g(_vm._b({
                staticClass: "mr-2",
                attrs: {
                  "icon": "",
                  "href": item.external_url,
                  "target": "_blank"
                }
              }, 'ix-button-white', attrs, false), on), [_c(VIcon, {
                attrs: {
                  "color": "blue-grey"
                }
              }, [_vm._v("mdi-information-variant ")])], 1)];
            }
          }], null, true)
        }, [_vm._v("\n          Go to detailed information at " + _vm._s(item.source.name) + ".\n        ")]) : _vm._e(), _vm._v(" "), _c(VBtn, {
          staticClass: "mb-2 custom-border-box",
          attrs: {
            "outlined": "",
            "icon": ""
          }
        }, [_c(VIcon, [_vm._v("mdi-close ")])], 1)], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref46) {
        var item = _ref46.item;
        return [_c(VDialog, {
          attrs: {
            "scrollable": "",
            "value": _setup.editDialog[item.id],
            "max-width": "80%"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref47) {
              var on = _ref47.on,
                attrs = _ref47.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                staticClass: "mr-2",
                attrs: {
                  "small": ""
                },
                on: {
                  "click": function click() {
                    _setup.editDialog[item.id] = true;
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n            mdi-pencil\n          ")])];
            }
          }], null, true)
        }, [_vm._v(" "), _c('ix-kpi-edit', {
          attrs: {
            "item": item
          },
          on: {
            "upsert": _setup.handleUpsert,
            "input": function input(v) {
              _setup.setEditDialog(item.id, v);
            }
          }
        })], 1), _vm._v(" "), _c(VDialog, {
          attrs: {
            "max-width": "70%"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref48) {
              var on = _ref48.on,
                attrs = _ref48.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  "small": ""
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-delete ")])];
            }
          }], null, true),
          model: {
            value: _setup.deleteDialog,
            callback: function callback($$v) {
              _setup.deleteDialog = $$v;
            },
            expression: "deleteDialog"
          }
        }, [_vm._v(" "), _c(VCard, [_c(VCardTitle, {
          staticClass: "text-h5"
        }, [_vm._v("\n            Are you sure you want to delete this item?\n          ")]), _vm._v(" "), _c(VCardActions, [_c(VSpacer), _vm._v(" "), _c(VBtn, {
          attrs: {
            "color": "blue darken-1",
            "text": ""
          },
          on: {
            "click": _setup.closeDelete
          }
        }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), _c(VBtn, {
          attrs: {
            "color": "blue darken-1",
            "text": "",
            "disabled": ""
          },
          on: {
            "click": function click($event) {
              return _setup.deleteItem(item);
            }
          }
        }, [_vm._v("\n              OK(WIP)\n            ")]), _vm._v(" "), _c(VSpacer)], 1)], 1)], 1)];
      }
    }], null, true),
    model: {
      value: _setup.selected,
      callback: function callback($$v) {
        _setup.selected = $$v;
      },
      expression: "selected"
    }
  })], 1) : !_setup.loading ? _c('div', [_vm._v("404")]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };